// extracted by mini-css-extract-plugin
export default {"layout":"LayoutPage_layout__loQTD","content_layout":"LayoutPage_content_layout__8bZKm"};